import { Flex, Image, useColorModeValue } from '@chakra-ui/react'
import { HSeparator } from 'components/separator/Separator'

// Logo servido diretamente da pasta /public
const LOGO_URL = process.env.PUBLIC_URL + '/logo.png'

export function SidebarBrand({ mini = false, hovered = false }) {
  const showFull = !mini || (mini && hovered)
  const showMark = mini && !hovered

  return (
    <Flex align="center" direction="column">
      {showFull && (
        <Image
          src={LOGO_URL}
          alt="PG Soluções Inteligentes"
          h="120px"
          w="auto"
          my="16px"
          objectFit="contain"
          draggable={false}
        />
      )}

      {showMark && (
        <Image
          src={LOGO_URL}
          alt="PG"
          h="64px"
          w="auto"
          my="28px"
          objectFit="contain"
          draggable={false}
        />
      )}

      <HSeparator mb="20px" bg="rgba(255,255,255,0.12)" />
    </Flex>
  )
}

export default SidebarBrand